import { render, staticRenderFns } from "./office-staff-edit.vue?vue&type=template&id=07b93a0e&scoped=true&lang=pug"
import script from "./office-staff-edit.vue?vue&type=script&lang=ts"
export * from "./office-staff-edit.vue?vue&type=script&lang=ts"
import style0 from "./office-staff-edit.vue?vue&type=style&index=0&id=07b93a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b93a0e",
  null
  
)

export default component.exports